import {useState} from "react";
import {Col, Container, Row} from "react-bootstrap";
import contactImg from "../assets/img/contact-totoro.png";
import "animate.css";
import TrackVisibility from "react-on-screen";

export const Contact = () => {

    const formInitialDetails = {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        message: ''
    }

    const [formDetails, setFormDetails] = useState(formInitialDetails);
    const [buttonText, setButtonText] = useState('Send');
    const [status, setStatus] = useState({});

    const onFormUpdate = (category, value) => {
        setFormDetails({
            ...formDetails,
            [category]: value
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault(); //prevent user from sending default values
        setButtonText('Sending...');
        let response = await fetch("https://api-personal-portfolio-s9w5.onrender.com/contact", {
            method: "POST",
            headers: {
                "Content-Type": "application/json;charset=utf-8",
            },
            body: JSON.stringify(formDetails),

        });
        setButtonText("Sent");
        let result = await response.json();
        setFormDetails(formInitialDetails);
        if (result.code === 200) {
            setStatus({success: true, message: 'Message sent successfully'})
        } else {
            setStatus({success: false, message: 'Something went wrong, please try again later.'})
        }
    }

    return (
        <section className="contact" id="connect">




            <Container>
                <TrackVisibility>
                    {({ isVisible}) =>
                        <div className={isVisible ? "animate__animated animate__fadeInUp" : "animate__animated animate__fadeOutDown"}
                             style={{ opacity: isVisible ? 1 : 0, transition: "opacity 0.5s ease-in" }}>
                <Row className="align-items-center">
                    <Col size={12} md={6}>
                        <img src={contactImg} alt="Contact Me" className="img-fluid w-50"/>
                    </Col>
                    <Col size={12} md={6}>
                        <h2>Get In Touch</h2>
                        <form onSubmit={handleSubmit}>
                            <Row>
                                <Col size={12} md={6} className="px-1">
                                    <input type="text" value={formDetails.firstName} placeholder="First Name" onChange={(e) => onFormUpdate('firstName', e.target.value)}/>
                                </Col>
                                <Col size={12} md={6} className="px-1">
                                    <input type="text" value={formDetails.lastName} placeholder="Last Name" onChange={(e) => onFormUpdate('lastName', e.target.value)}/>
                                </Col>
                                <Col size={12} md={6} className="px-1">
                                    <input type="email" value={formDetails.email} placeholder="Email Address" onChange={(e) => onFormUpdate('email', e.target.value)}/>
                                </Col>
                                <Col size={12} md={6} className="px-1">
                                    <input type="tel" value={formDetails.message} placeholder="Phone No." onChange={(e) => onFormUpdate('phone', e.target.value)}/>
                                </Col>
                                <Col size={12} className="px-1">
                                    <textarea rows="6" value={formDetails.message} placeholder="Message" onChange={(e) => onFormUpdate('message', e.target.message)}/>
                                    <button type="submit"><span>{buttonText}</span></button>
                                </Col>
                                {
                                    status.message &&
                                    <Col>
                                        <p className={status.success === false ? "danger" : "success"}>{status.message}</p>
                                    </Col>
                                }
                            </Row>
                        </form>
                    </Col>
                </Row>
                </div>}
                </TrackVisibility>
            </Container>

        </section>
    )
}